<template>
  <v-card
    outlined
    class="mb-5"
    min-height="250"
  >
    <v-card-text>
      <v-row no-gutters>
        <NameField
          :item="item"
          md="2"
          />
        <StatisticField
          :item="item"
          md="6"
          />
        <v-col cols="12" md="3">
          <v-row>
            {{$t('display/advert:statistic.generated')}}<b>: {{ item.advertStatistic.statisticAt}}</b>
          </v-row>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import NameField from '@/modules/display/views/advert/advert-statistic/NameField';
import StatisticField from "@/modules/display/views/advert/advert-statistic/StatisticField";

export default {
  name: "StatisticItem",
  components: {
    StatisticField,
    NameField
  },
  props: {
    item: Object
  }
}
</script>